import { useSearchParams } from "react-router-dom";
import { PageHero } from "@/components/PageHero";
import { InquiryForm } from "@/components/InquiryForm";
import { Reveal } from "@/components/Motion";
import { OCCASIONS, STEPS } from "@/data/site";

export default function CustomOrders() {
  const [params] = useSearchParams();
  const item = params.get("item");
  const occasion = params.get("occasion") || "";
  return (
    <main data-testid="custom-orders-page">
      <PageHero eyebrow="Custom Orders" lines={["Desserts", <span className="italic text-mocha">for the occasion.</span>]}
        intro="Custom cupcakes, cookies and dessert orders for birthdays, celebrations, showers, corporate events and other special occasions." />
      <section className="mx-auto max-w-[1440px] px-5 md:px-10 pb-28 grid lg:grid-cols-12 gap-16">
        <aside className="lg:col-span-4 space-y-12">
          <Reveal className="relative h-[380px] overflow-hidden rounded-t-[999px]">
            <img src="/img/cupcake-hero.jpg" alt="Banana Biscoff cupcake" className="absolute inset-0 w-full h-full object-cover" />
          </Reveal>
          <Reveal>
            <p className="eyebrow mb-4">Perfect for</p>
            <ul className="space-y-2">{OCCASIONS.map((o) => <li key={o} className="font-display text-2xl">{o}</li>)}</ul>
          </Reveal>
          <div className="space-y-6">
            {STEPS.map((s) => (
              <Reveal key={s.n} className="border-t border-espresso/20 pt-4">
                <p className="font-display text-2xl"><span className="italic text-gold mr-3">{s.n}</span>{s.t}</p>
                <p className="text-mocha text-sm mt-2 leading-relaxed">{s.d}</p>
              </Reveal>
            ))}
          </div>
        </aside>
        <Reveal className="lg:col-span-7 lg:col-start-6 bg-linen p-6 sm:p-10 md:p-14 self-start">
          <p className="font-display text-4xl mb-2">{occasion.includes("Preorder") ? "Reserve your holiday order" : "Request a custom order"}</p>
          <p className="text-mocha mb-10">Share a few details and Lise will reply by email.</p>
          <InquiryForm key={occasion} kind="custom" preset={item ? [item] : []} presetOccasion={occasion} />
        </Reveal>
      </section>
    </main>
  );
}
